import { tabProps } from "../interfaces/sidebar";

export const tabs: tabProps[] = [
    {
        id: "my_account",
        label: "Mi perfil",
        icon: "my_account",
        navigate: "cuenta"
    },
    {
        id: "my_publications",
        label: "Publicaciones",
        icon: "my_publications",
        navigate: "mis_publicaciones"
    },
    {
        id: "my_buys",
        label: "Mi actividad",
        icon: "my_buys",
        navigate: "mis_compras"
    },
    {
        id: "mis_ofertas",
        label: "Mis ofertas",
        icon: "mis_ofertas",
        navigate: "mis_ofertas"
    },
    {
        id: "favorites",
        label: "Me gusta",
        icon: "favorites",
        navigate: "favoritos"
    }
];